import Vue from "vue";
import App from "./App";
import router from "./router";
import { store } from "./store/store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBars, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { faComment } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VCalendar from "v-calendar";
const moment = require("moment");
require("moment/locale/es");
const fb = require("./firebaseConfig.js");
import { firestorePlugin } from "vuefire";

Vue.use(firestorePlugin);

library.add(faBars, faComment, faExternalLinkAlt);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(require("vue-moment"), {
  moment
});

Vue.use(VCalendar, {
  firstDayOfWeek: 2
});

let app;
fb.auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      el: "#app",
      router,
      store,
      render: h => h(App),
      components: { App }
    });
  }
});
